export default __webpack_public_path__ + "static/media/Email.34c4b004.svg";